import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Product = ({
  products,
  className,
  productClassName,
  productTimelineIconClassName,
  goToProductDetail
}) => {
  return (
    <div
      className={`${className} ${styles.productsWrapper}`}
      id={products[0].id}>
      <div className={styles.productList}>
        {products && products.map((product, index) => {
          return (
            <div
              className={`${productClassName} ${styles.product}`}
              key={index}>
              {product?.image &&
              <div
                className={styles.productIcon}
                onClick={() => goToProductDetail(product?.id, product.data)}
                title={`${product.name} - ${product.year}`}
              >
                <img src={product.image} alt={`${product.name} - ${product.year}`}/>
              </div>}
              {product?.name && <div className={styles.productTitle} dangerouslySetInnerHTML={{ __html: product.name }} />}
              {product?.year && <div className={styles.productYear} dangerouslySetInnerHTML={{ __html: product.year }} />}
            </div>
          )
        })}
      </div>

      <div
        className={`${productTimelineIconClassName} ${styles.productTimelineIcon}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path id="Layer0_36_MEMBER_1_1_STROKES" data-name="Layer0 36 MEMBER 1 1 STROKES" d="M9.53,9.54A4.82,4.82,0,0,1,6,11,4.82,4.82,0,0,1,2.47,9.54,4.83,4.83,0,0,1,1,6,4.82,4.82,0,0,1,2.46,2.47,4.83,4.83,0,0,1,6,1,4.83,4.83,0,0,1,9.54,2.47,4.82,4.82,0,0,1,11,6,4.83,4.83,0,0,1,9.53,9.54Z"
              style={{fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2px"}}/>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

Product.propTypes = {
  goToProductDetail: PropTypes.func,
  productClassName: PropTypes.string,
  productTimelineIconClassName: PropTypes.string,
  className: PropTypes.string,
  products: PropTypes.array
}

export default Product;